import { smsTemplatePopulatedSchema } from "@redotech/redo-model/sms-template";
import * as z from "zod";

const getSmsTemplateByIdPopulatedInputSchema_ = z.object({ id: z.string() });
export interface GetSmsTemplateByIdPopulatedInput extends z.infer<
  typeof getSmsTemplateByIdPopulatedInputSchema_
> {}
export const getSmsTemplateByIdPopulatedInputSchema: z.ZodType<GetSmsTemplateByIdPopulatedInput> =
  getSmsTemplateByIdPopulatedInputSchema_;

const getSmsTemplateByIdPopulatedOutputSchema_ = z.object({
  template: smsTemplatePopulatedSchema,
});
export interface GetSmsTemplateByIdPopulatedOutput extends z.infer<
  typeof getSmsTemplateByIdPopulatedOutputSchema_
> {}
export const getSmsTemplateByIdPopulatedOutputSchema: z.ZodType<GetSmsTemplateByIdPopulatedOutput> =
  getSmsTemplateByIdPopulatedOutputSchema_;

export const getSmsTemplateByIdPopulated = {
  name: "getSmsTemplateByIdPopulated" as const,
  input: getSmsTemplateByIdPopulatedInputSchema,
  output: getSmsTemplateByIdPopulatedOutputSchema,
};
